"use client";

import { useCallback, useState } from "react";
import { toast } from "sonner";

import {
  loadCustomUmrahFlowStateFromSession,
  saveCustomUmrahFlowStateToSession,
} from "../state/custom-umrah-flow.persistence";
import type { CustomUmrahFlowState } from "../state/custom-umrah-flow.slice";

export function useCustomUmrahFlowPersist() {
  const [restoredState] = useState<CustomUmrahFlowState>(() =>
    loadCustomUmrahFlowStateFromSession(),
  );

  const persistFlowState = useCallback((state: CustomUmrahFlowState) => {
    const isPersisted = saveCustomUmrahFlowStateToSession(state);

    if (!isPersisted) {
      toast.error("Unable to save your custom Umrah selection.", {
        description: "Please retry your hotel selection.",
      });
    }
  }, []);

  return {
    restoredState,
    persistFlowState,
  };
}
